export default {"src":"/_next/static/media/binance.f8e30a81.svg","height":19,"width":145};